import { useCallback, useState } from "react";

import { useConfig } from "@4uhub/lib4uhub";

import {
  getNotificationsEnabled,
  saveNotificationsEnabled,
} from "../services/notificationPreference.service";

const isNotificationSupported = () => "Notification" in window;

const useNotificationPreference = () => {
  const { setConfig } = useConfig();

  const [enabled, setEnabled] = useState(getNotificationsEnabled);

  const [permission, setPermission] = useState<NotificationPermission | null>(
    isNotificationSupported() ? Notification.permission : null
  );

  const changeHandler = useCallback(
    async (checked: boolean) => {
      setEnabled(checked);
      saveNotificationsEnabled(checked);

      setConfig({});

      if (checked && isNotificationSupported()) {
        const result = await Notification.requestPermission();
        setPermission(result);
      }
    },
    [setConfig]
  );

  return { enabled, permission, changeHandler };
};

export default useNotificationPreference;
